// the content for each component is put into an obj with the key name of the component

const data_path = './data';

export const content = {
    social: {
        title: `Curricle Lens`,
        subtitle: `I'm the subtitle`,
        urls: {
            socialtag: '/social_media.jpg',
            project: 'http://lens.metalab.kimalbrecht.com/',
        },
        twitter: 'https://twitter.com',
        facebook: 'https://facebook.com'
    },
    legend: {
        title: 'Course types',
        subtitle: 'What are the course types about?',
        types: [
            { color: '#2ECC40', label: 'Only tought once', gradientId: 'grad-id-0' },
            { color: '#fe0404', label: '1st time tought', gradientId: 'grad-id-1' },
            { color: '#7144ab', label: '2nd time tought', gradientId: 'grad-id-2' },
            { color: '#5d66d5', label: '10 years', gradientId: 'grad-id-3' },
            { color: '#3896e1', label: '20 years', gradientId: 'grad-id-4' },
            { color: '#1fc6c5', label: '30 years', gradientId: 'grad-id-5' },

        ]
    },
    intro: {
        title: 'Curricle Lens',
        subtitle: 'The history of harvards academia unveiled',
        p1: 'Visualized, annotated, connected: what should the course catalog look like in the 21st century? Leveraging data and design in a post-disciplinary era.'
    },
    stories: [
        {
            id: 0,
            authors: [['Kim Albrecht', 'https://kimalbrecht.com']],
            introduction: {
                'title': `Oliver Hart`,
                'subtitle': `Oliver Simon D'Arcy Hart is a British-born American economist, currently the Andrew E. Furer Professor of Economics at Harvard University. Together with Bengt R. Holmström, he received the Nobel Memorial Prize in Economic Sciences in 2016.`
            },
            data: [
                {
                    id: 0,
                    url: `${data_path}/story-oliver-hart/oliver-hart-first-classes.json`
                },
                {
                    id: 1,
                    url: `${data_path}/story-oliver-hart/oliver-hart-all-classes.json`
                },
                {
                    id: 2,
                    url: `${data_path}/story-cs50/cs-data.json`
                },
            ],
            paragraphs: [
                {
                    id: 0,
                    title: ``,
                    text: `In 1993 Oliver Hart became a Professor at Harvard University. In his first year Hart teached five classes here represented as five red swooshes.`
                },
                {
                    id: 1,
                    title: ``,
                    text: `Throughout Harts career he introduced new classes and evolved as a lecturer.`
                },
            ],
            snippets: [
                {
                    pId: 0,
                    highlight: [],
                    pos: [110708, 1994],
                    title: ``,
                    text: `One of these classes was called ‘Contract Theory’.`
                },
                {
                    pId: 1,
                    highlight: [],
                    pos: [110708, 1994],
                    title: ``,
                    text: `One of these classes was called ‘Contract Theory’.`
                },
                {
                    pId: 2,
                    highlight: [110708],
                    pos: [110708, 2004],
                    title: `I'm another sniasfdawppet title`,
                    text: `In 2004 Hart stopped teaching ‘Contract Theory’ for nearly ten years.`
                },
                {
                    pId: 3,
                    pos: [112739, 1994],
                    highlight: [141174, 111664, 130992, 111306],
                    title: `I'm a snippet tithgfjfgdjhgfle`,
                    text: `I'm the snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
                {
                    pId: 4,
                    pos: [112739, 1998],
                    highlight: [148156, 114134],
                    title: `I'm another snippet title`,
                    text: `I'm another snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
                {
                    pId: 5,
                    pos: [112739, 2000],
                    highlight: [141174, 111664, 130992, 111306],
                    title: `I'm another sniasfdawppet title`,
                    text: `I'm another snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
            ]
        },
        {
            id: 1,
            authors: [['Kim Albrecht', 'https://kimalbrecht.com']],
            introduction: {
                'title': `Book History`,
                'subtitle': `"Book history" emerges as a scholarly field in the middle of the twentieth century, as electronic mass media inspired scholars to reflect on the technical and material dimensions of communication. Book history brought  a range of existing disciplines and scholarly practices into conversation, attracting the interests of historian, literary scholars, librarians, and archivists, as well as students of new media, graphic design, and visual culture.`
            },
            data: [
                {
                    id: 0,
                    url: `${data_path}/book-history-data.json`
                },
                {
                    id: 1,
                    url: `${data_path}/cs-data.json`
                },
            ],
            paragraphs: [
                {
                    id: 0,
                    title: ``,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    img_url: `https://upload.wikimedia.org/wikipedia/commons/7/74/MyGutenbergGalaxy_onBookchair.jpg`,
                    img_subline: `The Gutenberg Galaxy`,
                },
                {
                    id: 1,
                    title: `I'm a paragraph headline.`,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    id: 2,
                    title: ``,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    id: 3,
                    title: `I'm a paragraph headline.`,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    id: 4,
                    title: `I'm a paasdasdragraph headline.`,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    video_url: `https://player.vimeo.com/video/52466961`,
                    video_subline: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`,
                },
                {
                    id: 5,
                    title: ``,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    audio_url: `http://developer.mozilla.org/@api/deki/files/2926/=AudioTest_(1).ogg`,
                    audio_subline: `Audio subline. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`,
                },
            ],
            snippets: [
                {
                    pId: 0,
                    highlight: [],
                    pos: [113956, 1998],
                    title: `I'm a snippet tithgfjfgdjhgfle`,
                    text: `I'm the snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
                {
                    pId: 1,
                    pos: [112739, 1992],
                    highlight: [],
                    title: `I'm another snippet title`,
                    text: `I'm another snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
                {
                    pId: 2,
                    pos: [112739, 2002],
                    highlight: [116210],
                    title: `I'm another sniasfdawppet title`,
                    text: `I'm another snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
                {
                    pId: 3,
                    pos: [112739, 1994],
                    highlight: [141174, 111664, 130992, 111306],
                    title: `I'm a snippet tithgfjfgdjhgfle`,
                    text: `I'm the snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
                {
                    pId: 4,
                    pos: [112739, 1998],
                    highlight: [148156, 114134],
                    title: `I'm another snippet title`,
                    text: `I'm another snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
                {
                    pId: 5,
                    pos: [112739, 2000],
                    highlight: [141174, 111664, 130992, 111306],
                    title: `I'm another sniasfdawppet title`,
                    text: `I'm another snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
            ]
        },
        {
            id: 0,
            authors: [['Kim Albrecht', 'https://kimalbrecht.com']],
            introduction: {
                'title': `CS50`,
                'subtitle': `With more than 600 attending students in fall 2017 "Introduction to Computer Science" is one of the most well attended classes at Harvard. In this Visualization we will look at the origins and embeddings of the class.`
            },
            data: [
                {
                    id: 0,
                    url: `${data_path}/story-cs50/cs50-lectures-only.json`
                },
                {
                    id: 1,
                    url: `${data_path}/story-cs50/cs50-all.json`
                },
                {
                    id: 2,
                    url: `${data_path}/story-cs50/cs-data.json`
                },
            ],
            paragraphs: [
                {
                    id: 0,
                    title: ``,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    img_url: `https://upload.wikimedia.org/wikipedia/commons/7/74/MyGutenbergGalaxy_onBookchair.jpg`,
                    img_subline: `The Gutenberg Galaxy`,
                },
                {
                    id: 1,
                    title: `I'm a paragraph headline.`,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    id: 2,
                    title: ``,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    id: 3,
                    title: `I'm a paragraph headline.`,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    id: 4,
                    title: `I'm a paasdasdragraph headline.`,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    video_url: `https://player.vimeo.com/video/52466961`,
                    video_subline: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`,
                },
                {
                    id: 5,
                    title: ``,
                    text: `The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex!The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`
                },
                {
                    audio_url: `http://developer.mozilla.org/@api/deki/files/2926/=AudioTest_(1).ogg`,
                    audio_subline: `Audio subline. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps.`,
                },
            ],
            snippets: [
                {
                    pId: 0,
                    highlight: [],
                    pos: [152514, 1990],
                    title: `The swoosh`,
                    text: `This swoosh represents the well know class ‘Introduction to Computer Science’ known as CS50. According to our data the class got first taught in 1990.`
                },
                {
                    pId: 1,
                    pos: [152514, 1990],
                    highlight: [],
                    title: ``,
                    text: `Since then CS50 is thought every fall semester at Harvard until today.`
                },
                {
                    pId: 2,
                    pos: [112739, 2002],
                    highlight: [116210],
                    title: `I'm another sniasfdawppet title`,
                    text: `I'm another snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
                {
                    pId: 3,
                    pos: [112739, 1994],
                    highlight: [141174, 111664, 130992, 111306],
                    title: `I'm a snippet tithgfjfgdjhgfle`,
                    text: `I'm the snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
                {
                    pId: 4,
                    pos: [112739, 1998],
                    highlight: [148156, 114134],
                    title: `I'm another snippet title`,
                    text: `I'm another snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
                {
                    pId: 5,
                    pos: [112739, 2000],
                    highlight: [141174, 111664, 130992, 111306],
                    title: `I'm another sniasfdawppet title`,
                    text: `I'm another snippet text. The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.`
                },
            ]
        },
    ]
};

export default content;